
<template>
  <div id="games" v-if="!showMenu && homeButtonVisible">
    <div class="squareGame animated slideInLeft menu-open"
         :class="{ 'hover-active': hover }"
         @mouseenter="handleHover(true)"
         @mouseleave="handleHover( false)"
         @click="goToMenu">
      <div class="imgGame homepage"></div>
      <span class="gameTitle">Menu</span>
    </div>
  </div>
  <button class="close-btn animated fadeIn" @click="closeMenu" v-if="showMenu">X</button>

  <MainMenu v-if="showMenu" />

</template>
<script setup>
  import MainMenu from '../MainMenu.vue'

  import { ref, watch, onMounted } from 'vue'
  import { useRoute } from 'vue-router'

  import { inject } from 'vue'

  const uiState = inject('uiState')
  const homeButtonVisible = ref(true)

  // or reactively watch:
  watch(() => uiState.locationSearchOpen, val => {
      //homeButtonVisible.value = !val
  })

  const showMenu = ref(false)
  const hover = ref(false)
  const firstLoad = ref(true)

  const route = useRoute()

  watch(route, (to, from) => {
    console.log('Route changed from:', from.path, 'to:', to.path)

    if (!firstLoad.value) {
      closeMenu()
    }
  })

  // Mouse hover handler
  function handleHover(isEntering) {
    hover.value = isEntering
  }

  function goToMenu() {
    firstLoad.value = false

    const menu = document.querySelector('.menu-container')
    if (menu) {
      menu.classList.remove('slideOutLeft')
      menu.classList.add('slideInLeft')
    }

    const container = document.querySelector('.container')
    container.classList.remove('slideInRight')
    container.classList.add('slideOutRight')

    const menuOpenButton = document.querySelector('.menu-open')
    if (menuOpenButton) {
      menuOpenButton.classList.remove('slideInLeft')
      menuOpenButton.classList.add('slideOutLeft')
    }

    setTimeout(() => {
      hover.value = false
      showMenu.value = true
      uiState.mainMenuOpen = true
      container.classList.add('hide')
    }, 250)
  }

  function closeMenu() {
    const menu = document.querySelector('.menu-container')
    if (menu) {
      menu.classList.remove('slideInLeft')
      menu.classList.add('slideOutLeft')
    }

    setTimeout(() => {
      showMenu.value = false
      uiState.mainMenuOpen = false

      const container = document.querySelector('.container')
      container.classList.remove('hide')
      container.classList.remove('slideOutRight')
      container.classList.add('slideInRight')

      const menuOpenButton = document.querySelector('.menu-open')
      if (menuOpenButton) {
        menuOpenButton.classList.remove('slideOutLeft')
        menuOpenButton.classList.add('slideInLeft')
      }
    }, 250)
  }
</script>



<style scoped>
  .close-btn {
    position: absolute;
    top: 15px;
    right: 20px;
    background: rgba(0, 0, 0, 0.8);
    border: none;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 18px;
    border-radius: 5px;
    transition: background 0.3s;
    display: block;
    width: inherit;
  }

    .close-btn:hover {
      background: rgba(255, 0, 0, 0.8);
    }

  .menu-container {
    position: relative;
  }
  #games{
      top:0;
  }
</style>
